package org.hs_soft.runmynesto.pages.login.mvi

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModel
import org.hs_soft.runmynesto.domain.model.login.LoginStateEnum

sealed class LoginEvent
{
    data class ResetPassword(
        val verifyCode:String,
        val newPassword:String
    ):LoginEvent()

    data class SendCodeForResetPassword(
        val userName: String,
    ):LoginEvent()

    data class SetLoginState(val loginState: LoginStateEnum)

    data class InitWindowsSize(val windowsSize: WindowSizeModel) : LoginEvent()

    data class OnUserNameChange(val value:String): LoginEvent()

    data class OnPasswordChange(val value:String): LoginEvent()

    data class OnMFAChange(val value:String): LoginEvent()




    data class OnSignInClick(
        val userName:String,
        val password:String,
        val mfsCode:String,
        val onSuccess:()->Unit,
    ): LoginEvent()

    data class OnFailureLogin(val error:String): LoginEvent()

    data object UpdateIsLoggedInStatus : LoginEvent()

}